<template>
    <div>
        <notification-bell id="notificationBell"
                           :size="16"
                           :count="notificationCount"
                           :ding="playNotificationSound"
                           :upper-limit="9"
                           counter-location="upperRight"
                           counter-style="roundRectangle"
                           counter-background-color="#FF0000"
                           counter-text-color="#FFFFFF"
                           icon-color="#FFFFFF"
                            />

        <b-popover target="notificationBell" triggers="hover" placement="bottomleft" size="lg" class="wide-popover" :delay="{ show: 50, hide: 1000 }" v-if="notifications.length">
            <template #title>
                Latest unseen notifications
            </template>

            <b-table striped hover :items="notifications" :fields="fields" size="lg" thead-class="hidden_header">
                <template #cell(subject)="data">
                    <b-link :href="notificationLinkUrl + data.item.id">{{ data.value }}</b-link>
                    <br />
                    <strong>{{ data.item.event }}</strong>
                </template>
            </b-table>

        </b-popover>

    </div>

</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import NotificationBell from 'vue-notification-bell'
    import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
    import axios from 'axios';
    import ErrorsMixin from '../../mixins/ErrorsMixin';

    Vue.use(BootstrapVue);
    Vue.component('notification-bell', NotificationBell);
    
    export default {
        name: 'NotificationIcon',
        mixins: [ErrorsMixin],
        props: {
            hubUrl: {
                type: String,
                required: true
            },
            notificationLinkUrl: {
                type: String,
                required: true
            },
            apiBaseUrl: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {
                connection: null,
                initialized: false,
                playNotificationSound: false,
                notificationCount: 0,
                messages: [],
                notifications: [],
                fields: ['subject']
            }
        },
        methods: {
            startConnection: function () {
                return this.connection.start().catch(function (err) {
                    return console.error(err.toSting());
                });
            },
            loadNotificationSettings: function () {
                if (this.initialized) {
                    var url = this.apiBaseUrl;
                    if (!url.endsWith('/')) url += '/';
                    url += 'userprofile/bool/EnableNotificationSound';
                    axios
                        .get(url)
                        .then(response => {
                            this.playNotificationSound = response.data;
                        })
                        .catch(ex => {
                            var errors = this.handleAxiosException(ex);
                            this.showErrorsToast(errors);
                        });
                }
            },

            retrieve5LatestNotifications() {

                const httpRequestParameter = {
                    searchTerm: this.searchTerm,
                    pageNr: this.pageNr,
                    pageSize: this.pageSize,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                    IncludeSources: this.checkedEventSourceTypes,
                    RequiresCount: this.requiresCount
                }

                console.log(JSON.stringify(httpRequestParameter));

                var url = this.apiBaseUrl + '/Notification/unseen/5';
                console.log('URL: ' + url);

                return axios
                    .get(url)
                    .then(response => {
                        //console.log('DATA Icon:')
                        //console.log(JSON.stringify(response.data));
                        if (response.data) this.notifications = response.data;
                    })

                    .catch(function (error) {
                        console.log(error);
                    });
            },

        },
        created: function () {
            this.connection = new HubConnectionBuilder()
                .withUrl(this.hubUrl)
                .configureLogging(LogLevel.Information)
                .build();
            var thisVueApp = this;
            this.connection.onclose(() => {
                thisVueApp.startConnection();
            });
            this.connection.on("NotificationCountsChanged", message => {
                thisVueApp.notificationCount = message.unseenNotifications;
                thisVueApp.retrieve5LatestNotifications();
            });
            this.connection.on("NotificationSettingsChanged", () => {
                thisVueApp.loadNotificationSettings();
            });
        },
        mounted: function () {
            //this.startConnection()
            //    .then(() => {
            //        this.connection
            //            .invoke("GetNotificationCounts")
            //            .then(message => {
            //                this.notificationCount = message.unseenNotifications;
            //                this.initialized = true;
            //                this.loadNotificationSettings();
            //            });
            //    })
            //this.retrieve5LatestNotifications();
        }
    }
</script>
<style scoped>
    div >>> .wide-popover {
        max-width: 400px;
        width: 350px;
    }

    div >>> .hidden_header {
        display: none;
    }
</style>
